(function () {
  if (window.CLC) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $all(root, sel) {
    var list = Array.prototype.slice.call(root.querySelectorAll(sel));
    if (root.matches && root.matches(sel)) list.unshift(root);
    return list;
  }
  function own(root, sel, scope) {
    return Array.prototype.slice.call(root.querySelectorAll(sel)).filter(function (el) {
      return el.closest(scope) === root;
    });
  }
  function onView(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(true); return null; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { cb(e.isIntersecting, e); });
    }, opts || { threshold: 0.15 });
    io.observe(el);
    return io;
  }
  function once(el, key) {
    if (el['__clc_' + key]) return false;
    el['__clc_' + key] = true;
    return true;
  }

    function slider(root) {
    if (!once(root, 'slider')) return;
    var track = root.querySelector('[data-clc-track]') || root.firstElementChild;
    if (!track) return;
    var prev = own(root, '[data-clc-prev]', '[data-clc-slider]');
    var next = own(root, '[data-clc-next]', '[data-clc-slider]');
    var dotsBox = own(root, '[data-clc-dots]', '[data-clc-slider]')[0];
    var counter = own(root, '[data-clc-counter]', '[data-clc-slider]')[0];
    var loop = root.hasAttribute('data-loop');
    var autoplay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    var timer = null, paused = false, inView = true, raf = 0;

    function slides() { return Array.prototype.slice.call(track.children).filter(function (s) { return s.offsetParent !== null || s.getClientRects().length; }); }
    function positions() {
      var max = track.scrollWidth - track.clientWidth;
      var base = track.getBoundingClientRect().left - track.scrollLeft;
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var pos = [];
      slides().forEach(function (s) {
        var x = Math.min(Math.round(s.getBoundingClientRect().left - base - pad), max);
        x = Math.max(0, x);
        if (!pos.length || Math.abs(x - pos[pos.length - 1]) > 2) pos.push(x);
      });
      if (!pos.length) pos.push(0);
      return pos;
    }
    function index() {
      var pos = positions(), x = track.scrollLeft, best = 0;
      pos.forEach(function (p, i) { if (Math.abs(p - x) < Math.abs(pos[best] - x)) best = i; });
      if (x >= track.scrollWidth - track.clientWidth - 2) best = pos.length - 1;
      return best;
    }
    function go(i, smooth) {
      var pos = positions();
      if (loop) i = (i + pos.length) % pos.length;
      i = Math.max(0, Math.min(i, pos.length - 1));
      track.scrollTo({ left: pos[i], behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
    }
    function buildDots() {
      if (!dotsBox) return;
      var n = positions().length;
      if (dotsBox.children.length === n) return;
      dotsBox.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'clc-slider__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (j) { b.addEventListener('click', function () { go(j); restart(); }); })(i);
        dotsBox.appendChild(b);
      }
      dotsBox.hidden = n < 2;
    }
    function update() {
      raf = 0;
      var i = index(), n = positions().length;
      if (dotsBox) Array.prototype.forEach.call(dotsBox.children, function (d, j) {
        d.classList.toggle('is-active', j === i);
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
      prev.forEach(function (b) { b.disabled = !loop && i === 0; });
      next.forEach(function (b) { b.disabled = !loop && i >= n - 1; });
      root.classList.toggle('is-static', n < 2);
      var tr = track.getBoundingClientRect();
      slides().forEach(function (s) {
        var r = s.getBoundingClientRect();
        var visible = r.right > tr.left + 4 && r.left < tr.right - 4;
        s.classList.toggle('is-visible', visible);
        if (!visible) s.querySelectorAll('video').forEach(function (v) { if (!v.hasAttribute('data-clc-keep-playing')) v.pause(); });
      });
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() {
      stop();
      if (autoplay && !reduceMotion && !paused && inView) timer = setInterval(function () {
        var i = index(), n = positions().length;
        go(i >= n - 1 ? 0 : i + 1);
      }, autoplay);
    }

    prev.forEach(function (b) { b.addEventListener('click', function () { go(index() - 1); restart(); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { go(index() + 1); restart(); }); });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { buildDots(); schedule(); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });
    if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '0');

    if (root.hasAttribute('data-drag')) {
      var down = false, sx = 0, sl = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false; track.classList.remove('is-dragging');
        go(index());
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    }

    if (autoplay) {
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        root.addEventListener(ev, function () { paused = true; stop(); }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        root.addEventListener(ev, function () { paused = false; restart(); });
      });
      onView(root, function (v) { inView = v; restart(); }, { threshold: 0.3 });
    }
    if ('ResizeObserver' in window) new ResizeObserver(function () { buildDots(); schedule(); }).observe(track);
    buildDots();
    update();
    restart();
    root.classList.add('is-ready');
  }

    function marquee(root) {
    if (!once(root, 'marquee')) return;
    var track = root.querySelector('.clc-marquee__track') || root;
    var group = track.querySelector('.clc-marquee__group');
    if (!group) return;
    var speed = parseFloat(root.getAttribute('data-speed')) || 50;

    function fill() {
      Array.prototype.slice.call(track.querySelectorAll('[data-clc-clone]')).forEach(function (c) { c.remove(); });
      var gw = group.getBoundingClientRect().width;
      if (!gw) return;
      var need = Math.ceil(root.getBoundingClientRect().width / gw) + 1;
      for (var i = 0; i < need; i++) {
        var c = group.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-clc-clone', '');
        c.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
        track.appendChild(c);
      }
      root.style.setProperty('--clc-marquee-duration', (gw / speed) + 's');
      root.classList.add('is-ready');
    }
    var lastW = 0;
    function maybeFill() {
      var w = root.getBoundingClientRect().width;
      if (Math.abs(w - lastW) > 1) { lastW = w; fill(); }
    }
    if ('ResizeObserver' in window) new ResizeObserver(maybeFill).observe(root);
    else window.addEventListener('resize', maybeFill);
    group.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', fill, { once: true });
    });
    maybeFill();
    onView(root, function (v) { root.classList.toggle('is-offscreen', !v); }, { threshold: 0 });
  }

    function accordion(root) {
    if (!once(root, 'accordion')) return;
    if (root.getAttribute('data-clc-accordion') !== 'single') return;
    own(root, 'details', '[data-clc-accordion]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        own(root, 'details', '[data-clc-accordion]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

    function tabs(root) {
    if (!once(root, 'tabs')) return;
    var list = own(root, '[role="tab"]', '[data-clc-tabs]');
    function select(tab, focus) {
      list.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !on; panel.classList.toggle('is-active', on); }
      });
      if (focus) tab.focus();
    }
    list.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % list.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + list.length) % list.length;
        if (e.key === 'Home') j = 0;
        if (e.key === 'End') j = list.length - 1;
        if (j !== null) { e.preventDefault(); select(list[j], true); }
      });
    });
    var initial = list.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || list[0];
    if (initial) select(initial);
  }

    function video(root) {
    if (!once(root, 'video')) return;
    var v = root.tagName === 'VIDEO' ? root : root.querySelector('video');
    if (!v) return;
    var box = root.tagName === 'VIDEO' ? v.parentElement : root;
    var btn = box.querySelector('[data-clc-play]');
    var autoInView = root.hasAttribute('data-autoplay') || v.hasAttribute('data-autoplay');
    function load() {
      if (v.__clcLoaded) return;
      v.__clcLoaded = true;
      v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.getAttribute('data-src'); });
      if (v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      if (v.querySelector('source[data-src]') || v.getAttribute('data-src')) v.load();
    }
    function sync() {
      box.classList.toggle('is-playing', !v.paused);
      if (btn) btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    }
    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);
    if (btn) btn.addEventListener('click', function () {
      load();
      if (v.paused) {
        document.querySelectorAll('[data-clc-video] video').forEach(function (o) { if (o !== v && !o.muted) o.pause(); });
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else v.pause();
    });
    if (autoInView && !reduceMotion) {
      v.muted = true; v.playsInline = true;
      onView(box, function (visible) {
        if (visible) { load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      }, { threshold: 0.25 });
    } else {
      onView(box, function (visible) { if (visible) load(); }, { rootMargin: '200px' });
    }
    sync();
  }

    function embed(root) {
    if (!once(root, 'embed')) return;
    function play() {
      if (root.querySelector('iframe')) return;
      var src = root.getAttribute('data-clc-embed');
      var yt = src.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/);
      var vm = src.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (yt) src = 'https://www.youtube-nocookie.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
      else if (vm) src = 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      var f = document.createElement('iframe');
      f.src = src;
      f.title = root.getAttribute('data-title') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      root.appendChild(f);
      root.classList.add('is-playing');
    }
    root.addEventListener('click', play);
    root.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); } });
    if (!root.hasAttribute('tabindex')) root.setAttribute('tabindex', '0');
    root.setAttribute('role', 'button');
  }

    function countup(el) {
    if (!once(el, 'countup')) return;
    var target = parseFloat(el.getAttribute('data-clc-countup'));
    if (isNaN(target)) return;
    var decimals = (String(target).split('.')[1] || '').length;
    var dur = parseInt(el.getAttribute('data-duration'), 10) || 1600;
    var fmt = function (n) { return n.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); };
    if (reduceMotion) { el.textContent = fmt(target); return; }
    el.textContent = fmt(0);
    var io = onView(el, function (v) {
      if (!v) return;
      if (io) io.disconnect();
      var t0 = performance.now();
      (function step(t) {
        var p = Math.min(1, (t - t0) / dur), eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased);
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    }, { threshold: 0.5 });
  }

    function reveal(el) {
    if (!once(el, 'reveal')) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var io = onView(el, function (v) {
      if (v) { el.classList.add('is-visible'); if (io && !el.hasAttribute('data-repeat')) io.disconnect(); }
      else if (el.hasAttribute('data-repeat')) el.classList.remove('is-visible');
    }, { threshold: 0.1 });
  }

  var registry = {
    '[data-clc-slider]': slider,
    '[data-clc-marquee]': marquee,
    '[data-clc-accordion]': accordion,
    '[data-clc-tabs]': tabs,
    '[data-clc-video]': video,
    '[data-clc-embed]': embed,
    '[data-clc-countup]': countup,
    '[data-clc-reveal]': reveal
  };

  function init(root) {
    root = root || document;
    Object.keys(registry).forEach(function (sel) {
      $all(root, sel).forEach(function (el) {
        try { registry[sel](el); } catch (err) { if (window.console) console.warn('[cl-common]', sel, err); }
      });
    });
  }

  window.CLC = { init: init, version: '1.0.0' };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-clc-track] > *');
    if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'start' });
  });
})();
